import { LkMunMehApi } from '@/api/resources'
import { Adapter } from '@/store/createCrudModule'

const apiMunMeh = new LkMunMehApi()
const adapterMunMeh = new Adapter(apiMunMeh)

export { apiMunMeh }
export { adapterMunMeh }
